import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Return() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Reference No",
      accessorKey: "Reference",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Description	",
      accessorKey: "Description",
    },
    {
      header: "Vat",
      accessorKey: "Vat",
    },
    {
      header: "Price",
      accessorKey: "Price",
    },
    {
      header: "Total",
      accessorKey: "Total",
    },
    {
      header: "Added By	",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },
  ]);
  const [data] = useState([
       {
        SN: 1,
        Reference: "000140",
        Date: "2024-01-03 03:03:19	",
        Description:"05404444444",
        Vat: "45.65",
        Price: "304.35",
        Total:"350",
        AddedBy:"Demo Test Account",
  
       },
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Return",
      path: "addReturn"
    },
    
  ]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"All Return"}
        buttonData={buttonData}
       
      />
    </main>
  );
}

export default Return;
